import { get, post, put } from "./index";
export function getList(params) {

    return get('/api/admin/match', params);
}
export function update(id, params) {
    return put(`/api/admin/match/${id}`, params);
}
export function add(params) {
    return post('/api/admin/match', params);
}
export function getDetails(id) {
    return get(`/api/admin/match/${id}`);
}
// export function update(id,params){
//     return put(`/api/admin/match/${id}`,params);
// }